export default (el) => {
    el.querySelector('.dropdown__trigger').addEventListener('click', (event) => {
        if (!event.target.classList.contains('dropdown__link') && !event.target.classList.contains('dropdown__group')) {
            event.preventDefault();
            if (document.querySelector('.dropdown__panel.-open') && document.querySelector('.dropdown__panel.-open') !== el.querySelector('.dropdown__panel')) {
                document.querySelector('.dropdown__panel.-open').classList.remove('-open');
            }
            el.querySelector('.dropdown__panel').classList.toggle('-open');
            el.classList.toggle('-open');
        }
    });
};
